import store from "../store/index";
//------------
// get marker
//------------
export default function getMarker(name) {
  const this_store = store;
  const markers = this_store.getters["combat/getMarkers"]
  let marker = markers.find((a) => a.name == name);
  return marker;
}
